import React from "react";
import StringerList from "../../components/News/StringerList";
import { ToastContainer } from "react-toastify";

const News = () => {
  return (
    <div className='constituency-section'>
      <ToastContainer />
      <div className='pageTitle flex items-center justify-between pr-5 heading-sec pl-4'>
        <h1 className='heading-text'>News - Stringers</h1>
      </div>
      <div className='constituency-map'>
        <StringerList />
      </div>
    </div>
  );
};

export default News;
